export const getRemarkType = (type = '') => {
  if (!type) return 'remarks';

  const parsedType = type.toLowerCase().trim();

  // Zorg dat alle keys beginnen met hooi_new_task_
  let normalized = parsedType.startsWith('hooi_new_task_')
    ? parsedType
    : parsedType.replace(/^hooi_new_/, 'hooi_new_task_');

  // trailing underscores weghalen
  normalized = normalized.replace(/_+$/, '');

  // Uitzonderingen behouden
  switch (normalized) {
    case 'testdrive':
      return 'test_drive_remarks';
    case 'spotrepair':
      return 'spot_repair_remarks';
    case 'eindinspectie':
    case 'inspection':
    case 'final_inspection':
      return 'final_inspection_remarks';
    case 'exterior_polish':
      return 'polish_exterior_remarks';
    case 'attach_plates':
      return 'attach_replate_remarks';
    case 'reparatie':
      return 'repair_remarks';
    case 'apk_uitvoeren':
      return 'apk_remarks';
    case 'terugroepactie':
      return 'recall_remarks';
    default:
      return `${normalized}_remarks`;
  }
};
